import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import userStatisticsApi from '../../api/userStatistics';

// 获取用户概览统计数据
export const fetchUserOverview = createAsyncThunk(
  'userStatistics/fetchUserOverview',
  async (params, { rejectWithValue }) => {
    try {
      const response = await userStatisticsApi.getUserOverview(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 获取用户趋势统计数据
export const fetchUserTrend = createAsyncThunk(
  'userStatistics/fetchUserTrend',
  async (params, { rejectWithValue }) => {
    try {
      const response = await userStatisticsApi.getUserTrend(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 获取用户分布统计数据
export const fetchUserDistribution = createAsyncThunk(
  'userStatistics/fetchUserDistribution',
  async (params, { rejectWithValue }) => {
    try {
      const response = await userStatisticsApi.getUserDistribution(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 初始状态
const initialState = {
  userOverview: {
    data: null,
    loading: false,
    error: null
  },
  userTrend: {
    data: null,
    loading: false,
    error: null
  },
  userDistribution: {
    data: null,
    loading: false,
    error: null
  }
};

// 创建slice
const userStatisticsSlice = createSlice({
  name: 'userStatistics',
  initialState,
  reducers: {
    // 可以添加额外的reducer函数
  },
  extraReducers: (builder) => {
    // 处理用户概览统计数据
    builder
      .addCase(fetchUserOverview.pending, (state) => {
        state.userOverview.loading = true;
        state.userOverview.error = null;
      })
      .addCase(fetchUserOverview.fulfilled, (state, action) => {
        state.userOverview.loading = false;
        state.userOverview.data = action.payload;
      })
      .addCase(fetchUserOverview.rejected, (state, action) => {
        state.userOverview.loading = false;
        state.userOverview.error = action.payload || 'Failed to fetch user overview';
      });

    // 处理用户趋势统计数据
    builder
      .addCase(fetchUserTrend.pending, (state) => {
        state.userTrend.loading = true;
        state.userTrend.error = null;
      })
      .addCase(fetchUserTrend.fulfilled, (state, action) => {
        state.userTrend.loading = false;
        state.userTrend.data = action.payload;
      })
      .addCase(fetchUserTrend.rejected, (state, action) => {
        state.userTrend.loading = false;
        state.userTrend.error = action.payload || 'Failed to fetch user trend';
      });

    // 处理用户分布统计数据
    builder
      .addCase(fetchUserDistribution.pending, (state) => {
        state.userDistribution.loading = true;
        state.userDistribution.error = null;
      })
      .addCase(fetchUserDistribution.fulfilled, (state, action) => {
        state.userDistribution.loading = false;
        state.userDistribution.data = action.payload;
      })
      .addCase(fetchUserDistribution.rejected, (state, action) => {
        state.userDistribution.loading = false;
        state.userDistribution.error = action.payload || 'Failed to fetch user distribution';
      });
  }
});

// 选择器
export const selectUserOverview = (state) => state.userStatistics.userOverview;
export const selectUserTrend = (state) => state.userStatistics.userTrend;
export const selectUserDistribution = (state) => state.userStatistics.userDistribution;

export default userStatisticsSlice.reducer; 